<template>
  <div class="app megaphon-app _dark-theme" :class="appThemeClassName">
    <div class="app-content">
      <!-- <AppAside/> -->
      <div class="right flex column">
        <AppHeader/>
        <main class="app-main flex-1 flex column" :style="$route.matched.find(c => c.name === 'AuthApp') ? 'margin-top: 0 !important' : ''">
          <router-view class="main-content width-all flex-1 align-start"/>
        </main>
      </div>
    </div>
    <AppFooter/>
    <!-- <Loader v-if="isLoading"/> -->
  </div>
</template>

<script>
import './assets/style/index.scss';

import AppHeader from './modules/common/cmps/AppHeader.vue';
import AppFooter from './modules/common/cmps/AppFooter.vue';
export default {
  name: 'MegaphonApp',
  components: {
    AppHeader,
    AppFooter,
  },
  computed: {
    uiConfig() {
      return this.$store.getters['settings/uiConfig'] || {};
    },
    appThemeClassName() {
      return '';
      return (this.uiConfig?.theme || 'none') + '-theme';
    },
  },
}
</script>
